// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.eventlogger

import org.multipaz.cbor.DataItem
import org.multipaz.eventlogger.EventPresentmentData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.crypto.X509CertChain
import org.multipaz.trustmanagement.TrustMetadata
import org.multipaz.cbor.buildCborArray
import org.multipaz.eventlogger.EventPresentmentDataDocument
import org.multipaz.trustmanagement.toDataItem
import org.multipaz.trustmanagement.fromDataItem

fun EventPresentmentData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "ElH8FPonyvwOgTjBV4Pcdsbn9yS6_mjBR8RhaLBf5KA")
val EventPresentmentData_cborSchemaId = ByteString(18, 81, -4, 20, -6, 39, -54, -4, 14, -127, 56, -63, 87, -125, -36, 118, -58, -25, -9, 36, -70, -2, 104, -63, 71, -60, 97, 104, -80, 95, -28, -96)

fun EventPresentmentData.Companion.fromCbor(data: ByteArray): EventPresentmentData {
    return EventPresentmentData.fromDataItem(Cbor.decode(data))
}

val EventPresentmentData.Companion.cborSchemaId: ByteString
    get() = EventPresentmentData_cborSchemaId

fun EventPresentmentData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    val requesterName = this.requesterName
    if (requesterName != null) {
        builder.put("requesterName", Tstr(requesterName))
    }
    val requesterCertChain = this.requesterCertChain
    if (requesterCertChain != null) {
        builder.put("requesterCertChain", requesterCertChain.toDataItem())
    }
    val trustMetadata = this.trustMetadata
    if (trustMetadata != null) {
        builder.put("trustMetadata", trustMetadata.toDataItem())
    }
    val array = this.requestedDocuments.let {
        buildCborArray {
            for (value in it) {
                add(value.toDataItem())
            }
        }
    }
    builder.put("requestedDocuments", array)
    return builder.end().build()
}

fun EventPresentmentData.Companion.fromDataItem(dataItem: DataItem): EventPresentmentData {
    val requesterName0 = if (dataItem.hasKey("requesterName")) {
        dataItem["requesterName"].asTstr
    } else {
        null
    }
    val requesterCertChain0 = if (dataItem.hasKey("requesterCertChain")) {
        X509CertChain.fromDataItem(dataItem["requesterCertChain"])
    } else {
        null
    }
    val trustMetadata0 = if (dataItem.hasKey("trustMetadata")) {
        TrustMetadata.fromDataItem(dataItem["trustMetadata"])
    } else {
        null
    }
    val array0 = dataItem["requestedDocuments"].let {
        buildList<EventPresentmentDataDocument> {
            for (value in it.asArray) {
                add(EventPresentmentDataDocument.fromDataItem(value))
            }
        }
    }
    val requestedDocuments = array0
    return EventPresentmentData(
        requesterName = requesterName0,
        requesterCertChain = requesterCertChain0,
        trustMetadata = trustMetadata0,
        requestedDocuments = requestedDocuments,
    )
}
